import React, { createContext, useContext } from "react";
import { useHomeService } from "../services/Home.service";

let operationsAllowed: any = {};
const HomeFacadeContext = createContext(operationsAllowed);

export const HomeFacadeProvider = (props: any) => {
  const homeService = useHomeService();

  const getNotificiations = () => {
    return homeService.getNotifications();
  };

  operationsAllowed = {
    getNotificiations,
  };

  return (
    <HomeFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </HomeFacadeContext.Provider>
  );
};

export const useHomeFacade = () => {
  return useContext(HomeFacadeContext);
};
